var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white rounded-lg shadow-card p-4 w-56 z-10 centered"},[_c('p',{staticClass:"text-center opacity-75"},[_vm._t("default",[_vm._v("I am popup!")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }